import styled from 'styled-components';
import FilterChip from './components/FilterChip';
import { useEffect } from 'react';

interface LaunchAreaFilters {
  areas: { id: number; name: string }[];
  selectedAreas: number[];
  handleClick: (id: number) => void;
}
const LaunchAreaFilters = ({
  areas,
  selectedAreas,
  handleClick
}: LaunchAreaFilters) => {
  useEffect(() => {}, [selectedAreas]);
  return (
    <Container>
      {areas.map(area => (
        <FilterChip
          key={area.id}
          id={area.id}
          name={area.name}
          isSelected={selectedAreas.includes(area.id)}
          handleClick={handleClick}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    flex-wrap: nowrap;
    overflow-x: auto;

    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export default LaunchAreaFilters;
